/**
 * Возвращает начальное состояние формы панели.
 * Используется при создании, сбросе и закрытии формы.
 */
function getDefaultPanelData() {
  return {
    basic: {
      name: '',
      sipAccount: '',
    },
    network: {
      manufacturer: '',
      ipAddress: '',
      login: '',
      password: '',
      applyToAll: false,
      rtspUrl: '',
    },
    access: [
      {
        deviceTypeId: '',
        lockTypeId: 1,
        usesApi: false,
        dtmf: '',
        openLink: '',
        isActive: true,
      },
    ],
    users: {
      selectedSections: [],
      available_to_all_residents: false,
    },
  }
}

export default {
  state: {
    panels: [],
    panelsMeta: {},
    isOpenAddPanel: false,
    isEditMode: false,
    editingPanelId: null,
    currentStep: 'AddPanelBasic',
    manufacturers: [],
    controlledDeviceTypes: [],
    lockTypes: {},
    availableSections: [],
    steps: [
      {
        id: 'AddPanelBasic',
        label: 'Основное',
      },
      {
        id: 'AddPanelNetwork',
        label: 'Сеть',
      },
      {
        id: 'AddPanelAccess',
        label: 'Доступ',
      },
      {
        id: 'AddPanelUsers',
        label: 'Пользователи',
      },
    ],
    panelData: getDefaultPanelData(),
  },
  getters: {
    panels: state => state.panels,
    panelsMeta: state => state.panelsMeta,
    isOpenAddPanel: state => state.isOpenAddPanel,
    isEditMode: state => state.isEditMode,
    editingPanelId: state => state.editingPanelId,
    currentStep: state => state.currentStep,
    steps: state => state.steps,
    manufacturers: state => state.manufacturers,
    manufacturersOptions: state =>
      state.manufacturers.map(m => ({ id: m.id, label: m.name })),
    controlledDeviceTypes: state => state.controlledDeviceTypes,
    controlledDeviceTypesOptions: state =>
      state.controlledDeviceTypes.map(d => ({ id: d.id, label: d.name })),
    lockTypes: state => state.lockTypes,
    lockTypesOptions: state =>
      Object.entries(state.lockTypes).map(([id, name]) => ({
        id: Number(id),
        label: name,
      })),
    availableSections: state => state.availableSections,
    availableSectionsOptions: state =>
      state.availableSections.map(s => ({
        id: s.id,
        label: s.name || '',
      })),
    panelData: state => state.panelData,
  },
  mutations: {
    SET_PANELS(state, payload) {
      state.panels = payload
    },
    ADD_NEW_PANEL(state, payload) {
      const currentPage = state.panelsMeta.current_page || 1
      const perPage = state.panelsMeta.per_page || 15

      if (currentPage === 1) {
        state.panels.unshift(payload)
        if (state.panels.length > perPage) {
          state.panels.pop()
        }
      }

      if (state.panelsMeta.total !== undefined) {
        state.panelsMeta.total++
      }
    },
    UPDATE_PANEL(state, payload) {
      const index = state.panels.findIndex(
        panel => panel.panel_id === payload.panel_id
      )
      if (index !== -1) {
        state.panels.splice(index, 1, payload)
      }
    },
    REMOVE_PANEL(state, payload) {
      state.panels = state.panels.filter(
        panel => !payload.includes(panel.panel_id)
      )

      if (state.panelsMeta.total !== undefined) {
        state.panelsMeta.total -= payload.length
      }
    },
    SET_PANELS_META(state, payload) {
      state.panelsMeta = payload
    },
    SET_MANUFACTURERS(state, payload) {
      state.manufacturers = payload
    },
    SET_CONTROLLED_DEVICE_TYPES(state, payload) {
      state.controlledDeviceTypes = payload
    },
    SET_LOCK_TYPES(state, payload) {
      state.lockTypes = payload
    },
    SET_AVAILABLE_SECTIONS(state, payload) {
      state.availableSections = payload
    },
    SET_TOGGLE_ADD_PANEL(state, payload) {
      state.isOpenAddPanel = payload
      if (!payload) {
        state.panelData = getDefaultPanelData()
        state.isEditMode = false
        state.editingPanelId = null
      }
      state.currentStep = 'AddPanelBasic'
    },
    SET_EDIT_MODE(state, { panelId, panelData }) {
      state.isEditMode = true
      state.editingPanelId = panelId
      if (panelData) {
        state.panelData = panelData
      }
    },
    SET_CURRENT_STEP(state, payload) {
      state.currentStep = payload
    },
    SET_PANEL_DATA(state, { key, value }) {
      state.panelData[key] = value
    },
    RESET_PANEL_FORM(state) {
      state.panelData = getDefaultPanelData()
      state.isEditMode = false
      state.editingPanelId = null
      state.currentStep = 'AddPanelBasic'
    },
  },
  actions: {
    setPanels({ commit }, payload) {
      commit('SET_PANELS', payload)
    },
    addNewPanel({ commit }, payload) {
      commit('ADD_NEW_PANEL', payload)
    },
    updatePanel({ commit }, payload) {
      commit('UPDATE_PANEL', payload)
    },
    removePanel({ commit }, panelIds) {
      commit('REMOVE_PANEL', panelIds)
    },
    setPanelsMeta({ commit }, payload) {
      commit('SET_PANELS_META', payload)
    },
    setManufacturers({ commit }, payload) {
      commit('SET_MANUFACTURERS', payload)
    },
    setControlledDeviceTypes({ commit }, payload) {
      commit('SET_CONTROLLED_DEVICE_TYPES', payload)
    },
    setLockTypes({ commit }, payload) {
      commit('SET_LOCK_TYPES', payload)
    },
    setAvailableSections({ commit }, payload) {
      commit('SET_AVAILABLE_SECTIONS', payload)
    },
    setToggleAddPanel({ commit }, payload) {
      commit('SET_TOGGLE_ADD_PANEL', payload)
    },
    setEditMode({ commit }, payload) {
      commit('SET_EDIT_MODE', payload)
    },
    setCurrentStep({ commit }, payload) {
      commit('SET_CURRENT_STEP', payload)
    },
    setPanelData({ commit }, { key, value }) {
      commit('SET_PANEL_DATA', { key, value })
    },
    resetPanelForm({ commit }) {
      commit('RESET_PANEL_FORM')
    },
  },
}
